import { useRecordHistory } from '@/entities/database';

import { HistoryList } from './HistoryList';

/** What changed in one record (the same entries as the database's History, narrowed). */
export function RecordHistory({ recordId, databaseId }: { recordId: string; databaseId: string }) {
  return (
    <HistoryList query={useRecordHistory(recordId)} databaseId={databaseId} recordId={recordId} />
  );
}
